const tpBaseData = {
  assessItem: 'AssessItem',
  versionNo: 'VersionNo',
  isEffective: 'IsEffective',
  category: 'Category',
  assessContent: 'AssessContent',
  citationBasis: 'CitationBasis',
  score: 'Score',
  breachExample: 'BreachExample',
  msg: {}
};
export default tpBaseData;



// WEBPACK FOOTER //
// ./src/page/assess/tpBaseData/lang/tpBaseData.en.js